<template>
  <el-drawer
    :visible.sync="drawerVisible"
    :size="drawerSize"
    :title="title"
    :append-to-body="true"
    custom-class="quote-preview-drawer"
  >
    <div class="quote-preview-document">
      <div class="container">

      <!-- 品牌头部 -->
      <div class="brand-header">
        <div class="brand-logo">
          <div class="logo-box">COSMO<br>Plat</div>
          <div class="brand-text">
            <div class="main">卡奥斯 COSMOPlat</div>
            <div class="sub">工业互联网平台 · 销供协同数字人</div>
          </div>
        </div>
        <div class="brand-doc-type">报价方案预览</div>
      </div>

      <!-- 核心结论 -->
      <div class="hero-card">
        <div class="hero-title">报价方案已生成 · RFQ-EW-WM-AI15</div>
        <div class="hero-main">
          华东智洗 · AIoT 变频洗衣机智能控制器<br>
          500 台首批报价方案
        </div>
        <div class="hero-stats">
          <div class="hero-stat">
            <span class="val">318.89</span>
            <span class="lbl">出厂价（元/台）</span>
          </div>
          <div class="hero-stat">
            <span class="val">360.35</span>
            <span class="lbl">含税单价（元/台）</span>
          </div>
          <div class="hero-stat">
            <span class="val">180,175.00</span>
            <span class="lbl">含税合计（元）</span>
          </div>
          <div class="hero-stat">
            <span class="val">17.6%</span>
            <span class="lbl">税后净利率</span>
          </div>
        </div>
        <div class="hero-badge">
          <span>30 天交付</span> · <span>200 台第 20 天 + 300 台第 30 天</span> · <span>BOM 87/87 匹配</span>
        </div>
      </div>

      <!-- 风险预警 -->
      <div class="risk-bar">
        <div class="icon">⚠️</div>
        <div class="content">
          <div class="title">风险预警（3 项）</div>
          <div class="desc">
            ① 目标价 350 元（含税）vs 我方 360.35 元，超 2.9%，需议价策略或降本方案<br>
            ② STM32F407 协议价过期 3 天，现货价 +8%，已同步采购核实<br>
            ③ WiFi 模组交期 45 天，产能排程无缓冲，建议提前备货
          </div>
        </div>
      </div>

      <!-- 产物卡片 1: BOM 解析 -->
      <details class="deliverable-card" open>
        <summary>
          <div class="card-num">1</div>
          <div class="card-info">
            <div class="card-title">BOM 解析确认表</div>
            <div class="card-meta">87/87 项成功匹配 · 81 项协议价 · 6 项现货价 · 0 项缺失</div>
          </div>
          <div class="card-status status-done">已完成</div>
        </summary>
        <div class="card-body">
          <p><strong>BOM 文件口径说明：</strong>BOM Excel 中列示的单价为<strong>市场参考价</strong>口径，87 项合计 <strong>349.17 元</strong>；智能体报价时采用 <strong>ERP 协议价</strong>（约市场价 5 折），BOM 物料成本合计 <strong>174.10 元/台</strong>。差异即工厂的采购竞争力来源。</p>

          <table>
            <thead>
              <tr><th>类别</th><th class="td-center">项数</th><th class="td-center">协议价</th><th class="td-center">现货价</th><th class="td-center">缺失</th><th>典型物料</th></tr>
            </thead>
            <tbody>
              <tr><td>主动器件（IC/半导体/模组）</td><td class="td-center td-highlight">20</td><td class="td-center">18</td><td class="td-center td-danger">2</td><td class="td-center">0</td><td>STM32F407VGT6、ESP32-WROOM-32</td></tr>
              <tr><td>功率器件与二极管</td><td class="td-center td-highlight">6</td><td class="td-center">6</td><td class="td-center">0</td><td class="td-center">0</td><td>IPB017N10N3 G、1N4007、FR107</td></tr>
              <tr><td>被动器件（阻容感/磁珠）</td><td class="td-center td-highlight">28</td><td class="td-center">26</td><td class="td-center td-danger">2</td><td class="td-center">0</td><td>多层陶瓷电容、厚膜电阻</td></tr>
              <tr><td>连接器/接插件</td><td class="td-center td-highlight">9</td><td class="td-center">8</td><td class="td-center td-danger">1</td><td class="td-center">0</td><td>电源插座、LCD 接口、天线座</td></tr>
              <tr><td>结构件/辅料（含PCB/变压器）</td><td class="td-center td-highlight">24</td><td class="td-center">23</td><td class="td-center td-danger">1</td><td class="td-center">0</td><td>PCB 沉金、开关变压器 T1、散热片</td></tr>
              <tr style="background:var(--primary-soft);font-weight:700;"><td>合计</td><td class="td-center">87</td><td class="td-center">81</td><td class="td-center">6</td><td class="td-center">0</td><td>协议价命中率 93.1%</td></tr>
            </tbody>
          </table>

          <h4>重点物料与风险标记</h4>
          <table>
            <thead>
              <tr><th>物料</th><th>型号</th><th>用量</th><th class="td-num">单价</th><th class="td-num">金额</th><th>价格来源</th><th>交期</th><th>风险标记</th></tr>
            </thead>
            <tbody>
              <tr><td class="td-danger">主控芯片</td><td>STM32F407VGT6</td><td class="td-center">1</td><td class="td-num">28.50</td><td class="td-num td-highlight">28.50</td><td><span class="tag tag-orange">现货价</span></td><td class="td-center td-danger">12 周</td><td class="td-danger">协议价过期 3 天</td></tr>
              <tr><td class="td-danger">WiFi 模组</td><td>ESP32-WROOM-32</td><td class="td-center">1</td><td class="td-num">18.00</td><td class="td-num td-highlight">18.00</td><td><span class="tag tag-orange">现货价</span></td><td class="td-center td-danger">45 天</td><td class="td-danger">交期超长</td></tr>
              <tr><td>三相逆变驱动</td><td>IR2104S</td><td class="td-center">3</td><td class="td-num">6.80</td><td class="td-num">20.40</td><td><span class="tag tag-green">协议价</span></td><td class="td-center">2 周</td><td><span class="tag tag-green">正常</span></td></tr>
              <tr><td>功率 MOSFET</td><td>IPB017N10N3 G</td><td class="td-center">6</td><td class="td-num">5.80</td><td class="td-num">34.80</td><td><span class="tag tag-green">协议价</span></td><td class="td-center">2 周</td><td><span class="tag tag-green">正常</span></td></tr>
              <tr><td>AC-DC 电源</td><td>LH15-10B24</td><td class="td-center">1</td><td class="td-num">22.00</td><td class="td-num">22.00</td><td><span class="tag tag-green">协议价</span></td><td class="td-center">2 周</td><td><span class="tag tag-green">正常</span></td></tr>
              <tr><td>霍尔传感器</td><td>ACS712ELCTR-20A</td><td class="td-center">3</td><td class="td-num">8.50</td><td class="td-num">25.50</td><td><span class="tag tag-green">协议价</span></td><td class="td-center">3 周</td><td><span class="tag tag-green">正常</span></td></tr>
              <tr><td class="td-danger">散热片</td><td>定制 30x20x10mm</td><td class="td-center">1</td><td class="td-num">2.80</td><td class="td-num">2.80</td><td><span class="tag tag-orange">现货价</span></td><td class="td-center">3 周</td><td class="td-danger">协议价过期</td></tr>
              <tr><td>湿度传感器</td><td>SHT30-DIS-B</td><td class="td-center">1</td><td class="td-num">12.50</td><td class="td-num">12.50</td><td><span class="tag tag-green">协议价</span></td><td class="td-center">3 周</td><td><span class="tag tag-green">正常</span></td></tr>
            </tbody>
          </table>

          <details class="sub-group">
            <summary>
              <span>▼ 主动器件完整明细（20 项）</span>
              <span class="sub-count">20</span>
            </summary>
            <div class="sub-body">
              <table>
                <thead><tr><th>#</th><th>位号</th><th>物料名称</th><th>品牌</th><th>型号</th><th>封装</th><th class="td-center">用量</th><th class="td-num">单价</th><th class="td-num">金额</th><th>来源</th><th>备注</th></tr></thead>
                <tbody>
                  <tr><td>1</td><td>U1</td><td>ARM Cortex-M4主控</td><td>ST</td><td>STM32F407VGT6</td><td>LQFP-100</td><td class="td-center">1</td><td class="td-num td-danger">28.50</td><td class="td-num td-danger">28.50</td><td><span class="tag tag-orange">现货</span></td><td class="td-danger">协议价过期3天</td></tr>
                  <tr><td>2</td><td>U2</td><td>三相逆变器驱动IC</td><td>Infineon</td><td>IR2104S</td><td>SOP-8</td><td class="td-center">3</td><td class="td-num">6.80</td><td class="td-num">20.40</td><td><span class="tag tag-green">协议</span></td><td>3路电机驱动</td></tr>
                  <tr><td>3</td><td>U3</td><td>LDO线性稳压器</td><td>TI</td><td>TPS7A7001</td><td>SOT-223</td><td class="td-center">1</td><td class="td-num">3.20</td><td class="td-num">3.20</td><td><span class="tag tag-green">协议</span></td><td>5V转3.3V</td></tr>
                  <tr><td>4</td><td>U4</td><td>WiFi通信模组</td><td>乐鑫</td><td>ESP32-WROOM-32</td><td>SMD-38</td><td class="td-center">1</td><td class="td-num td-danger">18.00</td><td class="td-num td-danger">18.00</td><td><span class="tag tag-orange">现货</span></td><td class="td-danger">交期45天</td></tr>
                  <tr><td>5</td><td>U5</td><td>EEPROM存储器</td><td>Microchip</td><td>24LC256-I/SN</td><td>SOIC-8</td><td class="td-center">1</td><td class="td-num">2.80</td><td class="td-num">2.80</td><td><span class="tag tag-green">协议</span></td><td>参数存储</td></tr>
                  <tr><td>6</td><td>U6</td><td>FLASH存储器</td><td>Winbond</td><td>W25Q128JVSIQ</td><td>SOIC-8</td><td class="td-center">1</td><td class="td-num">4.50</td><td class="td-num">4.50</td><td><span class="tag tag-green">协议</span></td><td>程序存储</td></tr>
                  <tr><td>7</td><td>U7</td><td>运放</td><td>TI</td><td>LM358DR</td><td>SOIC-8</td><td class="td-center">2</td><td class="td-num">1.20</td><td class="td-num">2.40</td><td><span class="tag tag-green">协议</span></td><td>电流采样</td></tr>
                  <tr><td>8</td><td>U8</td><td>比较器</td><td>ST</td><td>LM393DT</td><td>SOT-23-5</td><td class="td-center">2</td><td class="td-num">0.85</td><td class="td-num">1.70</td><td><span class="tag tag-green">协议</span></td><td>过流保护</td></tr>
                  <tr><td>9</td><td>U9</td><td>霍尔传感器</td><td>Allegro</td><td>ACS712ELCTR-20A</td><td>SOIC-8</td><td class="td-center">3</td><td class="td-num">8.50</td><td class="td-num">25.50</td><td><span class="tag tag-green">协议</span></td><td>电流检测</td></tr>
                  <tr><td>10</td><td>U10</td><td>温度传感器</td><td>TI</td><td>TMP75AID</td><td>SOIC-8</td><td class="td-center">1</td><td class="td-num">5.20</td><td class="td-num">5.20</td><td><span class="tag tag-green">协议</span></td><td>NTC备用</td></tr>
                  <tr><td>11</td><td>U12</td><td>AC-DC电源模块</td><td>MORNSUN</td><td>LH15-10B24</td><td>DIP-24</td><td class="td-center">1</td><td class="td-num">22.00</td><td class="td-num">22.00</td><td><span class="tag tag-green">协议</span></td><td>220V转24V</td></tr>
                  <tr><td>12</td><td>U13</td><td>继电器(主电源)</td><td>宏发</td><td>HF115F/024-1ZS3</td><td>DIP-6</td><td class="td-center">1</td><td class="td-num">3.50</td><td class="td-num">3.50</td><td><span class="tag tag-green">协议</span></td><td>主电源控制</td></tr>
                  <tr><td>13</td><td>U14</td><td>继电器(进水阀)</td><td>宏发</td><td>JQC-3FF-024-1ZS</td><td>DIP-5</td><td class="td-center">2</td><td class="td-num">2.80</td><td class="td-num">5.60</td><td><span class="tag tag-green">协议</span></td><td>进水/排水控制</td></tr>
                  <tr><td>14</td><td>U15</td><td>继电器(电机)</td><td>欧姆龙</td><td>G5Q-1A4-DC24V</td><td>DIP-4</td><td class="td-center">3</td><td class="td-num">4.50</td><td class="td-num">13.50</td><td><span class="tag tag-green">协议</span></td><td>电机控制</td></tr>
                  <tr><td>15</td><td>U16</td><td>CAN收发器</td><td>TI</td><td>SN65HVD230</td><td>SOIC-8</td><td class="td-center">1</td><td class="td-num">6.80</td><td class="td-num">6.80</td><td><span class="tag tag-green">协议</span></td><td>工业通信(预留)</td></tr>
                  <tr><td>16</td><td>U17</td><td>RS485收发器</td><td>Maxim</td><td>MAX485ESA+</td><td>SOIC-8</td><td class="td-center">1</td><td class="td-num">4.50</td><td class="td-num">4.50</td><td><span class="tag tag-green">协议</span></td><td>modbus通信</td></tr>
                  <tr><td>17</td><td>U18</td><td>看门狗芯片</td><td>TI</td><td>TPS3823-33DBVT</td><td>SOT-23-5</td><td class="td-center">1</td><td class="td-num">2.20</td><td class="td-num">2.20</td><td><span class="tag tag-green">协议</span></td><td>系统复位保护</td></tr>
                  <tr><td>18</td><td>U19</td><td>LED驱动芯片</td><td>TI</td><td>TLC59208F</td><td>SSOP-16</td><td class="td-center">1</td><td class="td-num">3.80</td><td class="td-num">3.80</td><td><span class="tag tag-green">协议</span></td><td>显示屏背光</td></tr>
                  <tr><td>19</td><td>U20</td><td>ADC芯片</td><td>TI</td><td>ADS1115IDGST</td><td>VSSOP-10</td><td class="td-center">1</td><td class="td-num">8.50</td><td class="td-num">8.50</td><td><span class="tag tag-green">协议</span></td><td>高精度采样</td></tr>
                  <tr><td>20</td><td>TH1</td><td>湿度传感器</td><td>Sensirion</td><td>SHT30-DIS-B</td><td>SMD-8</td><td class="td-center">1</td><td class="td-num">12.50</td><td class="td-num">12.50</td><td><span class="tag tag-green">协议</span></td><td>环境检测</td></tr>
                  <tr style="background:var(--surface-soft);font-weight:700;"><td colspan="7">小计</td><td class="td-num">—</td><td class="td-num">195.10</td><td>18协议+2现货</td><td></td></tr>
                </tbody>
              </table>
            </div>
          </details>

          <details class="sub-group">
            <summary>
              <span>▼ 功率器件与二极管完整明细（6 项）</span>
              <span class="sub-count">6</span>
            </summary>
            <div class="sub-body">
              <table>
                <thead><tr><th>#</th><th>位号</th><th>物料名称</th><th>品牌</th><th>型号</th><th>封装</th><th class="td-center">用量</th><th class="td-num">单价</th><th class="td-num">金额</th><th>来源</th><th>备注</th></tr></thead>
                <tbody>
                  <tr><td>16</td><td>Q1-Q6</td><td>功率MOSFET</td><td>Infineon</td><td>IPB017N10N3 G</td><td>TO-263</td><td class="td-center">6</td><td class="td-num">5.80</td><td class="td-num">34.80</td><td><span class="tag tag-green">协议</span></td><td>逆变器功率管</td></tr>
                  <tr><td>17</td><td>Q7-Q10</td><td>小信号MOSFET</td><td>LRC</td><td>L2N7002LT1G</td><td>SOT-23</td><td class="td-center">4</td><td class="td-num">0.35</td><td class="td-num">1.40</td><td><span class="tag tag-green">协议</span></td><td>逻辑控制</td></tr>
                  <tr><td>18</td><td>D1-D4</td><td>整流二极管</td><td>Yangjie</td><td>1N4007</td><td>DO-41</td><td class="td-center">4</td><td class="td-num">0.08</td><td class="td-num">0.32</td><td><span class="tag tag-green">协议</span></td><td>续流保护</td></tr>
                  <tr><td>19</td><td>D5-D8</td><td>快恢复二极管</td><td>Yangjie</td><td>FR107</td><td>DO-41</td><td class="td-center">4</td><td class="td-num">0.15</td><td class="td-num">0.60</td><td><span class="tag tag-green">协议</span></td><td>高频整流</td></tr>
                  <tr><td>20</td><td>D9</td><td>TVS保护二极管</td><td>Vishay</td><td>P6KE24CA</td><td>DO-15</td><td class="td-center">1</td><td class="td-num">1.20</td><td class="td-num">1.20</td><td><span class="tag tag-green">协议</span></td><td>过压保护</td></tr>
                  <tr><td>21</td><td>D10</td><td>肖特基二极管</td><td>Yangjie</td><td>SS34</td><td>SMA</td><td class="td-center">1</td><td class="td-num">0.45</td><td class="td-num">0.45</td><td><span class="tag tag-green">协议</span></td><td>防反接</td></tr>
                  <tr style="background:var(--surface-soft);font-weight:700;"><td colspan="7">小计</td><td class="td-num">—</td><td class="td-num">38.77</td><td>6协议+0现货</td><td></td></tr>
                </tbody>
              </table>
            </div>
          </details>

          <details class="sub-group">
            <summary>
              <span>▼ 被动器件完整明细（28 项）</span>
              <span class="sub-count">28</span>
            </summary>
            <div class="sub-body">
              <table>
                <thead><tr><th>#</th><th>位号</th><th>物料名称</th><th>品牌</th><th>型号</th><th>封装</th><th class="td-center">用量</th><th class="td-num">单价</th><th class="td-num">金额</th><th>来源</th><th>备注</th></tr></thead>
                <tbody>
                  <tr><td>22</td><td>C1,C2</td><td>电解电容 470uF/50V</td><td>Nichicon</td><td>UHE1H471MPD</td><td>DIP-10x16</td><td class="td-center">2</td><td class="td-num">2.50</td><td class="td-num">5.00</td><td><span class="tag tag-green">协议</span></td><td>主电源滤波</td></tr>
                  <tr><td>23</td><td>C3,C4</td><td>电解电容 100uF/25V</td><td>Samyoung</td><td>MVK25V100M</td><td>DIP-6x11</td><td class="td-center">2</td><td class="td-num">0.85</td><td class="td-num">1.70</td><td><span class="tag tag-green">协议</span></td><td>次级滤波</td></tr>
                  <tr><td>24</td><td>C5-C12</td><td>陶瓷电容 0.1uF/50V</td><td>Murata</td><td>GRM155R71H104KE19D</td><td>0402</td><td class="td-center">8</td><td class="td-num">0.08</td><td class="td-num">0.64</td><td><span class="tag tag-green">协议</span></td><td>去耦电容</td></tr>
                  <tr><td>25</td><td>C13-C20</td><td>陶瓷电容 10uF/25V</td><td>Murata</td><td>GRM188R61E106ME69D</td><td>0603</td><td class="td-center">8</td><td class="td-num">0.25</td><td class="td-num">2.00</td><td><span class="tag tag-green">协议</span></td><td>旁路滤波</td></tr>
                  <tr><td>26</td><td>C21-C24</td><td>陶瓷电容 1nF/50V</td><td>Murata</td><td>GRM1555C1H102JA01D</td><td>0402</td><td class="td-center">4</td><td class="td-num">0.05</td><td class="td-num">0.20</td><td><span class="tag tag-green">协议</span></td><td>高频滤波</td></tr>
                  <tr><td>27</td><td>C25</td><td>薄膜电容 0.22uF/275V</td><td>EPCOS</td><td>B32922C3224M</td><td>DIP-15</td><td class="td-center">1</td><td class="td-num td-danger">3.80</td><td class="td-num td-danger">3.80</td><td><span class="tag tag-orange">现货</span></td><td>安规电容X2</td></tr>
                  <tr><td>28</td><td>C26</td><td>薄膜电容 0.1uF/275V</td><td>EPCOS</td><td>B32921C3104M</td><td>DIP-12</td><td class="td-center">1</td><td class="td-num td-danger">2.50</td><td class="td-num td-danger">2.50</td><td><span class="tag tag-orange">现货</span></td><td>安规电容X2</td></tr>
                  <tr><td>29</td><td>C27</td><td>Y电容 4700pF/400V</td><td>Murata</td><td>DE2E3KY472MA3B</td><td>DIP-10</td><td class="td-center">1</td><td class="td-num">1.80</td><td class="td-num">1.80</td><td><span class="tag tag-green">协议</span></td><td>安规电容Y1</td></tr>
                  <tr><td>30</td><td>C28</td><td>固态电容 100uF/25V</td><td>Panasonic</td><td>EEFSX0E101XR</td><td>DIP-6x8</td><td class="td-center">1</td><td class="td-num">3.20</td><td class="td-num">3.20</td><td><span class="tag tag-green">协议</span></td><td>CPU供电</td></tr>
                  <tr><td>31</td><td>R1-R10</td><td>贴片电阻 10K 1%</td><td>Yageo</td><td>RC0402FR-0710KL</td><td>0402</td><td class="td-center">10</td><td class="td-num">0.03</td><td class="td-num">0.30</td><td><span class="tag tag-green">协议</span></td><td>上拉/分压</td></tr>
                  <tr><td>32</td><td>R11-R20</td><td>贴片电阻 100K 1%</td><td>Yageo</td><td>RC0402FR-07100KL</td><td>0402</td><td class="td-center">10</td><td class="td-num">0.03</td><td class="td-num">0.30</td><td><span class="tag tag-green">协议</span></td><td>分压电阻</td></tr>
                  <tr><td>33</td><td>R21-R30</td><td>贴片电阻 1K 1%</td><td>Yageo</td><td>RC0402FR-071KL</td><td>0402</td><td class="td-center">10</td><td class="td-num">0.03</td><td class="td-num">0.30</td><td><span class="tag tag-green">协议</span></td><td>限流电阻</td></tr>
                  <tr><td>34</td><td>R31-R35</td><td>贴片电阻 0.1Ω 1%</td><td>Yageo</td><td>RL0402FR-070R1L</td><td>0402</td><td class="td-center">5</td><td class="td-num">0.15</td><td class="td-num">0.75</td><td><span class="tag tag-green">协议</span></td><td>电流采样</td></tr>
                  <tr><td>35</td><td>R36-R40</td><td>贴片电阻 100Ω 1%</td><td>Yageo</td><td>RC0402FR-07100RL</td><td>0402</td><td class="td-center">5</td><td class="td-num">0.03</td><td class="td-num">0.15</td><td><span class="tag tag-green">协议</span></td><td>终端匹配</td></tr>
                  <tr><td>36</td><td>R41-R45</td><td>贴片电阻 4.7K 1%</td><td>Yageo</td><td>RC0402FR-074K7L</td><td>0402</td><td class="td-center">5</td><td class="td-num">0.03</td><td class="td-num">0.15</td><td><span class="tag tag-green">协议</span></td><td>偏置电阻</td></tr>
                  <tr><td>37</td><td>R46-R50</td><td>贴片电阻 1M 1%</td><td>Yageo</td><td>RC0402FR-071ML</td><td>0402</td><td class="td-center">5</td><td class="td-num">0.03</td><td class="td-num">0.15</td><td><span class="tag tag-green">协议</span></td><td>高阻分压</td></tr>
                  <tr><td>38</td><td>L1</td><td>功率电感 100uH</td><td>Sumida</td><td>CDRH124NP-101MC</td><td>SMD-12x12</td><td class="td-center">1</td><td class="td-num">4.50</td><td class="td-num">4.50</td><td><span class="tag tag-green">协议</span></td><td>DC-DC电感</td></tr>
                  <tr><td>39</td><td>L2</td><td>共模电感 10mH</td><td>EPCOS</td><td>B82793S0513N201</td><td>SMD-13x12</td><td class="td-center">1</td><td class="td-num">6.80</td><td class="td-num">6.80</td><td><span class="tag tag-green">协议</span></td><td>EMI滤波</td></tr>
                  <tr><td>40</td><td>C29-C32</td><td>陶瓷电容 22uF/16V</td><td>Murata</td><td>GRM188R61C226ME15D</td><td>0603</td><td class="td-center">4</td><td class="td-num">0.35</td><td class="td-num">1.40</td><td><span class="tag tag-green">协议</span></td><td>电源去耦</td></tr>
                  <tr><td>41</td><td>C33-C36</td><td>陶瓷电容 100pF/50V</td><td>Murata</td><td>GRM1555C1H101JA01D</td><td>0402</td><td class="td-center">4</td><td class="td-num">0.04</td><td class="td-num">0.16</td><td><span class="tag tag-green">协议</span></td><td>高频退耦</td></tr>
                  <tr><td>42</td><td>C37</td><td>钽电容 10uF/16V</td><td>AVX</td><td>TAJA106K016RNJ</td><td>SMD-A</td><td class="td-center">1</td><td class="td-num">2.80</td><td class="td-num">2.80</td><td><span class="tag tag-green">协议</span></td><td>音频耦合</td></tr>
                  <tr><td>43</td><td>R51-R55</td><td>贴片电阻 0Ω</td><td>Yageo</td><td>RC0402JR-070RL</td><td>0402</td><td class="td-center">5</td><td class="td-num">0.02</td><td class="td-num">0.10</td><td><span class="tag tag-green">协议</span></td><td>跳线/保险</td></tr>
                  <tr><td>44</td><td>R56-R60</td><td>贴片电阻 10Ω 1%</td><td>Yageo</td><td>RC0402FR-0710RL</td><td>0402</td><td class="td-center">5</td><td class="td-num">0.03</td><td class="td-num">0.15</td><td><span class="tag tag-green">协议</span></td><td>阻尼电阻</td></tr>
                  <tr><td>45</td><td>L3</td><td>磁珠 600Ω/100MHz</td><td>Murata</td><td>BLM15AG601SN1D</td><td>0402</td><td class="td-center">1</td><td class="td-num">0.35</td><td class="td-num">0.35</td><td><span class="tag tag-green">协议</span></td><td>EMI抑制</td></tr>
                  <tr><td>46</td><td>L4</td><td>磁珠 600Ω/100MHz</td><td>Murata</td><td>BLM15AG601SN1D</td><td>0402</td><td class="td-center">2</td><td class="td-num">0.35</td><td class="td-num">0.70</td><td><span class="tag tag-green">协议</span></td><td>电源EMI</td></tr>
                  <tr><td>47</td><td>D11</td><td>稳压二极管 5.1V</td><td>Yangjie</td><td>BZX84C5V1LT1G</td><td>SOT-23</td><td class="td-center">1</td><td class="td-num">0.25</td><td class="td-num">0.25</td><td><span class="tag tag-green">协议</span></td><td>基准电压</td></tr>
                  <tr><td>48</td><td>D12</td><td>发光二极管 红外</td><td>Everlight</td><td>IR333-A</td><td>DIP-3mm</td><td class="td-center">1</td><td class="td-num">0.45</td><td class="td-num">0.45</td><td><span class="tag tag-green">协议</span></td><td>遥控接收</td></tr>
                  <tr><td>49</td><td>D13</td><td>光耦</td><td>TLP(东芝)</td><td>TLP281-4</td><td>DIP-16</td><td class="td-center">1</td><td class="td-num">2.80</td><td class="td-num">2.80</td><td><span class="tag tag-green">协议</span></td><td>隔离通信</td></tr>
                  <tr style="background:var(--surface-soft);font-weight:700;"><td colspan="7">小计</td><td class="td-num">—</td><td class="td-num">43.40</td><td>26协议+2现货</td><td></td></tr>
                </tbody>
              </table>
            </div>
          </details>

          <details class="sub-group">
            <summary>
              <span>▼ 连接器完整明细（9 项）</span>
              <span class="sub-count">9</span>
            </summary>
            <div class="sub-body">
              <table>
                <thead><tr><th>#</th><th>位号</th><th>物料名称</th><th>品牌</th><th>型号</th><th>封装</th><th class="td-center">用量</th><th class="td-num">单价</th><th class="td-num">金额</th><th>来源</th><th>备注</th></tr></thead>
                <tbody>
                  <tr><td>41</td><td>J1</td><td>AC电源输入座</td><td>Cixi</td><td>DB-14-2P</td><td>DIP-2</td><td class="td-center">1</td><td class="td-num">1.20</td><td class="td-num">1.20</td><td><span class="tag tag-green">协议</span></td><td>220V输入</td></tr>
                  <tr><td>42</td><td>J2</td><td>电机接口座</td><td>Molex</td><td>43025-0400</td><td>DIP-4</td><td class="td-center">3</td><td class="td-num">2.50</td><td class="td-num">7.50</td><td><span class="tag tag-green">协议</span></td><td>三相电机连接</td></tr>
                  <tr><td>43</td><td>J3</td><td>进水阀接口</td><td>JST</td><td>XH-2.54-2P</td><td>DIP-2</td><td class="td-center">2</td><td class="td-num">0.60</td><td class="td-num">1.20</td><td><span class="tag tag-green">协议</span></td><td>进水/排水阀</td></tr>
                  <tr><td>44</td><td>J4</td><td>水位传感器接口</td><td>JST</td><td>ZH-1.5-3P</td><td>DIP-3</td><td class="td-center">1</td><td class="td-num">0.80</td><td class="td-num">0.80</td><td><span class="tag tag-green">协议</span></td><td>水位检测</td></tr>
                  <tr><td>45</td><td>J5</td><td>门锁接口</td><td>JST</td><td>XH-2.54-2P</td><td>DIP-2</td><td class="td-center">1</td><td class="td-num">0.60</td><td class="td-num">0.60</td><td><span class="tag tag-green">协议</span></td><td>安全门锁</td></tr>
                  <tr><td>46</td><td>J6</td><td>显示屏接口</td><td>HRS</td><td>DF13-10DS-1.25C</td><td>DIP-10</td><td class="td-center">1</td><td class="td-num">3.50</td><td class="td-num">3.50</td><td><span class="tag tag-green">协议</span></td><td>LCD/OLED连接</td></tr>
                  <tr><td>47</td><td>J7</td><td>按键面板接口</td><td>HRS</td><td>DF13-6DS-1.25C</td><td>DIP-6</td><td class="td-center">1</td><td class="td-num">2.20</td><td class="td-num">2.20</td><td><span class="tag tag-green">协议</span></td><td>按键矩阵</td></tr>
                  <tr><td>48</td><td>J8</td><td>蜂鸣器接口</td><td>JST</td><td>XH-2.54-2P</td><td>DIP-2</td><td class="td-center">1</td><td class="td-num">0.60</td><td class="td-num">0.60</td><td><span class="tag tag-green">协议</span></td><td>声音提示</td></tr>
                  <tr><td>49</td><td>J9</td><td>WiFi天线接口</td><td>I-PEX</td><td>I-PEX MHF4</td><td>SMD</td><td class="td-center">1</td><td class="td-num td-danger">1.50</td><td class="td-num td-danger">1.50</td><td><span class="tag tag-orange">现货</span></td><td>外接天线</td></tr>
                  <tr style="background:var(--surface-soft);font-weight:700;"><td colspan="7">小计</td><td class="td-num">—</td><td class="td-num">19.10</td><td>8协议+1现货</td><td></td></tr>
                </tbody>
              </table>
            </div>
          </details>

          <details class="sub-group">
            <summary>
              <span>▼ 结构件/辅料完整明细（24 项）</span>
              <span class="sub-count">24</span>
            </summary>
            <div class="sub-body">
              <table>
                <thead><tr><th>#</th><th>位号</th><th>物料名称</th><th>品牌</th><th>型号</th><th>封装</th><th class="td-center">用量</th><th class="td-num">单价</th><th class="td-num">金额</th><th>来源</th><th>备注</th></tr></thead>
                <tbody>
                  <tr><td>50</td><td>J10</td><td>调试/烧录接口</td><td>Cixi</td><td>IDC-2.54-4P</td><td>DIP-4</td><td class="td-center">1</td><td class="td-num">0.80</td><td class="td-num">0.80</td><td><span class="tag tag-green">协议</span></td><td>SWD/JTAG</td></tr>
                  <tr><td>51</td><td>Y1</td><td>晶振 8MHz</td><td>TXC</td><td>7B-8.000MEEQ-T</td><td>SMD-3.2x2.5</td><td class="td-center">1</td><td class="td-num">1.80</td><td class="td-num">1.80</td><td><span class="tag tag-green">协议</span></td><td>系统主频</td></tr>
                  <tr><td>52</td><td>Y2</td><td>晶振 32.768kHz</td><td>Seiko</td><td>SC-32S</td><td>SMD-3.2x1.5</td><td class="td-center">1</td><td class="td-num">1.20</td><td class="td-num">1.20</td><td><span class="tag tag-green">协议</span></td><td>RTC时钟</td></tr>
                  <tr><td>53</td><td>F1</td><td>保险丝 2A/250V</td><td>Littelfuse</td><td>021702.5MXEP</td><td>DIP-5x20</td><td class="td-center">1</td><td class="td-num">0.45</td><td class="td-num">0.45</td><td><span class="tag tag-green">协议</span></td><td>过流保护</td></tr>
                  <tr><td>54</td><td>RT1</td><td>NTC热敏电阻 10K</td><td>Shibaura</td><td>103AT-2</td><td>DIP-3</td><td class="td-center">1</td><td class="td-num">1.50</td><td class="td-num">1.50</td><td><span class="tag tag-green">协议</span></td><td>温度检测</td></tr>
                  <tr><td>55</td><td>RV1</td><td>压敏电阻 14D471K</td><td>EPCOS</td><td>B72214S0421K101</td><td>DIP-14</td><td class="td-center">1</td><td class="td-num">0.80</td><td class="td-num">0.80</td><td><span class="tag tag-green">协议</span></td><td>浪涌保护</td></tr>
                  <tr><td>56</td><td>LED1</td><td>电源指示灯 绿色</td><td>Everlight</td><td>333-2SURD/S530-A3</td><td>0805</td><td class="td-center">1</td><td class="td-num">0.25</td><td class="td-num">0.25</td><td><span class="tag tag-green">协议</span></td><td>电源指示</td></tr>
                  <tr><td>57</td><td>LED2</td><td>运行指示灯 蓝色</td><td>Everlight</td><td>333-2UBD/S530-A3</td><td>0805</td><td class="td-center">1</td><td class="td-num">0.35</td><td class="td-num">0.35</td><td><span class="tag tag-green">协议</span></td><td>WiFi状态</td></tr>
                  <tr><td>58</td><td>LED3</td><td>故障指示灯 红色</td><td>Everlight</td><td>333-2USD/S530-A3</td><td>0805</td><td class="td-center">1</td><td class="td-num">0.30</td><td class="td-num">0.30</td><td><span class="tag tag-green">协议</span></td><td>故障报警</td></tr>
                  <tr><td>59</td><td>BZ1</td><td>蜂鸣器 5V有源</td><td>富鸿达</td><td>TMB12A05</td><td>DIP-12x9</td><td class="td-center">1</td><td class="td-num">1.20</td><td class="td-num">1.20</td><td><span class="tag tag-green">协议</span></td><td>声音提示</td></tr>
                  <tr><td>60</td><td>SW1</td><td>复位按键</td><td>ALPS</td><td>SKHHLWA010</td><td>SMD-3x4</td><td class="td-center">1</td><td class="td-num">0.85</td><td class="td-num">0.85</td><td><span class="tag tag-green">协议</span></td><td>手动复位</td></tr>
                  <tr><td>61</td><td>SW2</td><td>模式选择拨码</td><td>C&K</td><td>SDBMA</td><td>SMD-5x2.5</td><td class="td-center">1</td><td class="td-num">2.50</td><td class="td-num">2.50</td><td><span class="tag tag-green">协议</span></td><td>工作模式选择</td></tr>
                  <tr><td>62</td><td>X1</td><td>散热片 铝型材</td><td>定制</td><td>30x20x10mm</td><td>定制</td><td class="td-center">1</td><td class="td-num td-danger">2.80</td><td class="td-num td-danger">2.80</td><td><span class="tag tag-orange">现货</span></td><td class="td-danger">MOSFET散热,协议价过期</td></tr>
                  <tr><td>63</td><td>X2</td><td>散热硅脂垫</td><td>Fujipoly</td><td>XR-Pe</td><td>30x20x1mm</td><td class="td-center">1</td><td class="td-num">0.80</td><td class="td-num">0.80</td><td><span class="tag tag-green">协议</span></td><td>导热绝缘</td></tr>
                  <tr><td>64</td><td>S1</td><td>PCB板 4层FR-4</td><td>定制</td><td>140x90x1.6mm</td><td>定制</td><td class="td-center">1</td><td class="td-num">15.00</td><td class="td-num">15.00</td><td><span class="tag tag-green">协议</span></td><td>沉金工艺</td></tr>
                  <tr><td>65</td><td>S2</td><td>外壳 塑料ABS</td><td>定制</td><td>150x100x35mm</td><td>定制</td><td class="td-center">1</td><td class="td-num">5.50</td><td class="td-num">5.50</td><td><span class="tag tag-green">协议</span></td><td>IP54防护等级</td></tr>
                  <tr><td>66</td><td>S3</td><td>固定螺丝 M3x6</td><td>标准件</td><td>M3x6不锈钢</td><td>标准</td><td class="td-center">4</td><td class="td-num">0.15</td><td class="td-num">0.60</td><td><span class="tag tag-green">协议</span></td><td>PCB固定</td></tr>
                  <tr><td>67</td><td>S4</td><td>铜柱 M3x10</td><td>标准件</td><td>M3x10双通</td><td>标准</td><td class="td-center">4</td><td class="td-num">0.25</td><td class="td-num">1.00</td><td><span class="tag tag-green">协议</span></td><td>支撑柱</td></tr>
                  <tr><td>68</td><td>S5</td><td>标签贴纸</td><td>定制</td><td>60x40mm不干胶</td><td>定制</td><td class="td-center">1</td><td class="td-num">0.50</td><td class="td-num">0.50</td><td><span class="tag tag-green">协议</span></td><td>型号/条码</td></tr>
                  <tr><td>69</td><td>S6</td><td>防静电袋</td><td>标准件</td><td>150x200mm</td><td>标准</td><td class="td-center">1</td><td class="td-num">0.30</td><td class="td-num">0.30</td><td><span class="tag tag-green">协议</span></td><td>静电防护</td></tr>
                  <tr><td>70</td><td>S7</td><td>吸塑托盘</td><td>定制</td><td>160x110x25mm</td><td>定制</td><td class="td-center">1</td><td class="td-num">2.20</td><td class="td-num">2.20</td><td><span class="tag tag-green">协议</span></td><td>运输防护</td></tr>
                  <tr><td>71</td><td>S8</td><td>外箱 瓦楞纸</td><td>标准件</td><td>300x200x150mm</td><td>标准</td><td class="td-center">1</td><td class="td-num">1.80</td><td class="td-num">1.80</td><td><span class="tag tag-green">协议</span></td><td>外包装</td></tr>
                  <tr><td>72</td><td>U11</td><td>整流桥</td><td>Yangjie</td><td>KBL410</td><td>DIP-4</td><td class="td-center">1</td><td class="td-num">1.80</td><td class="td-num">1.80</td><td><span class="tag tag-green">协议</span></td><td>220V整流</td></tr>
                  <tr><td>73</td><td>T1</td><td>开关变压器</td><td>定制</td><td>EI22 24V/5V</td><td>定制</td><td class="td-center">1</td><td class="td-num">8.50</td><td class="td-num">8.50</td><td><span class="tag tag-green">协议</span></td><td>隔离电源变压器</td></tr>
                  <tr style="background:var(--surface-soft);font-weight:700;"><td colspan="7">小计</td><td class="td-num">—</td><td class="td-num">52.80</td><td>23协议+1现货</td><td></td></tr>
                </tbody>
              </table>
            </div>
          </details>

          <h4>BOM 合计统计</h4>
          <table>
            <thead><tr><th>统计项</th><th class="td-num">数值</th></tr></thead>
            <tbody>
              <tr><td>物料总项数</td><td class="td-num">87</td></tr>
              <tr><td>用量合计</td><td class="td-num">196</td></tr>
              <tr><td>物料成本合计（市场价口径）</td><td class="td-num">349.17 元</td></tr>
              <tr><td>预估损耗（5%）</td><td class="td-num">17.46 元</td></tr>
              <tr style="background:var(--warning-soft)"><td><strong>BOM 总成本（市场价口径）</strong></td><td class="td-num td-highlight"><strong>366.63 元</strong></td></tr>
              <tr style="background:var(--success-soft)"><td><strong>BOM 协议价成本（报价口径）</strong></td><td class="td-num td-success"><strong>174.10 元</strong></td></tr>
              <tr><td>协议价命中率</td><td class="td-num">81/87（93.1%）</td></tr>
              <tr><td>现货价项数</td><td class="td-num">6/87（6.9%）</td></tr>
            </tbody>
          </table>
        </div>
      </details>

      <!-- 产物 2: 成本拆解 -->
      <details class="deliverable-card">
        <summary>
          <div class="card-num">2</div>
          <div class="card-info">
            <div class="card-title">成本拆解明细表</div>
            <div class="card-meta">完全成本 232.94 元/台 · 7 大项逐项展开 · 含子项 breakdown</div>
          </div>
          <div class="card-status status-done">已完成</div>
        </summary>
        <div class="card-body">
          <p><strong>公式：</strong>完全成本 = BOM 物料 + 制造费用(SMT) + 制造费用(DIP) + 制造费用(测试) + 直接人工 + 期间费用 + 专项(NRE 摊薄)</p>

          <div class="calc-card">
            <div class="calc-title">📦 BOM 物料 · 174.10 元/台</div>
            <div class="calc-row"><span class="lbl">主动器件（IC/半导体/模组，20项）</span><span class="val">195.10</span></div>
            <div class="calc-row"><span class="lbl">功率器件与二极管（6项）</span><span class="val">38.77</span></div>
            <div class="calc-row"><span class="lbl">被动器件（阻容感/磁珠，28项）</span><span class="val">43.40</span></div>
            <div class="calc-row"><span class="lbl">连接器/接插件（9项）</span><span class="val">19.10</span></div>
            <div class="calc-row"><span class="lbl">结构件/辅料（24项，含PCB沉金15.00、变压器T1 8.50）</span><span class="val">52.80</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row"><span class="lbl">市场价口径小计</span><span class="val">349.17</span></div>
            <div class="calc-row"><span class="lbl">协议价折扣（约5折）</span><span class="val">-175.07</span></div>
            <div class="calc-row calc-total"><span class="lbl">BOM 物料（报价口径）</span><span class="val">174.10</span></div>
          </div>

          <div class="calc-card">
            <div class="calc-title">🔧 制造费用（SMT）· 18.50 元/台</div>
            <div class="calc-row"><span class="lbl">贴装费（常规器件，850点×0.010元）</span><span class="val">8.50</span></div>
            <div class="calc-row"><span class="lbl">贴装费（QFN/BGA溢价，3颗×0.833元）</span><span class="val">2.50</span></div>
            <div class="calc-row"><span class="lbl">换线费（分摊，500台分摊1,000元）</span><span class="val">2.00</span></div>
            <div class="calc-row"><span class="lbl">AOI 自动光学检测（双面）</span><span class="val">3.00</span></div>
            <div class="calc-row"><span class="lbl">X-Ray 检测（3颗BGA/QFN）</span><span class="val">1.50</span></div>
            <div class="calc-row"><span class="lbl">回流焊能耗分摊</span><span class="val">1.00</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row calc-total"><span class="lbl">SMT 小计</span><span class="val">18.50</span></div>
          </div>

          <div class="calc-card">
            <div class="calc-title">🔌 制造费用（DIP）· 6.50 元/台</div>
            <div class="calc-row"><span class="lbl">插件工时费（8个异形件×0.438元）</span><span class="val">3.50</span></div>
            <div class="calc-row"><span class="lbl">波峰焊（含助焊剂）</span><span class="val">2.00</span></div>
            <div class="calc-row"><span class="lbl">手工补焊（按缺陷率预估）</span><span class="val">1.00</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row calc-total"><span class="lbl">DIP 小计</span><span class="val">6.50</span></div>
          </div>

          <div class="calc-card">
            <div class="calc-title">🧪 制造费用（测试）· 12.00 元/台</div>
            <div class="calc-row"><span class="lbl">FCT 功能测试（6项×标准费率）</span><span class="val">5.00</span></div>
            <div class="calc-row"><span class="lbl">AOI 外观检测（已计入SMT，此处不重复）</span><span class="val">—</span></div>
            <div class="calc-row"><span class="lbl">48h 老化测试（高温60℃连续72h，含抽样）</span><span class="val">4.00</span></div>
            <div class="calc-row"><span class="lbl">可靠性测试报告编制费</span><span class="val">3.00</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row calc-total"><span class="lbl">测试小计</span><span class="val">12.00</span></div>
          </div>

          <div class="calc-card">
            <div class="calc-title">👷 直接人工 · 6.24 元/台</div>
            <div class="calc-row"><span class="lbl">组装人工（0.5h × 6.48元/h）</span><span class="val">3.24</span></div>
            <div class="calc-row"><span class="lbl">测试人工（FCT + 老化测试工时）</span><span class="val">2.00</span></div>
            <div class="calc-row"><span class="lbl">包装人工</span><span class="val">1.00</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row calc-total"><span class="lbl">人工小计</span><span class="val">6.24</span></div>
          </div>

          <div class="calc-card">
            <div class="calc-title">📊 期间费用 · 13.00 元/台</div>
            <div class="calc-row"><span class="lbl">管理费用分摊（产品族费率2.23%）</span><span class="val">5.20</span></div>
            <div class="calc-row"><span class="lbl">销售费用分摊（销售额比例2.06%）</span><span class="val">4.80</span></div>
            <div class="calc-row"><span class="lbl">财务费用分摊（资金占用费）</span><span class="val">3.00</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row calc-total"><span class="lbl">期间费用小计</span><span class="val">13.00</span></div>
          </div>

          <div class="calc-card">
            <div class="calc-title">🆕 专项（NRE 摊薄）· 2.60 元/台</div>
            <div class="calc-row"><span class="lbl">钢网费（一次性800元 ÷ 500台）</span><span class="val">1.60</span></div>
            <div class="calc-row"><span class="lbl">程序烧录/首件确认（500元 ÷ 500台）</span><span class="val">1.00</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row calc-total"><span class="lbl">NRE 小计（首单）</span><span class="val">2.60</span></div>
            <div class="calc-row" style="font-size:11px;color:var(--muted)"><span class="lbl">年框5,000台时摊薄至</span><span class="val">0.26 元/台</span></div>
          </div>

          <div class="calc-card" style="background:var(--primary-soft);border:2px solid var(--primary);">
            <div class="calc-title" style="color:var(--primary-deep);font-size:16px;">💰 完全成本合计</div>
            <div class="calc-row"><span class="lbl">BOM 物料</span><span class="val">174.10</span></div>
            <div class="calc-row"><span class="lbl">SMT 制造</span><span class="val">18.50</span></div>
            <div class="calc-row"><span class="lbl">DIP 制造</span><span class="val">6.50</span></div>
            <div class="calc-row"><span class="lbl">测试</span><span class="val">12.00</span></div>
            <div class="calc-row"><span class="lbl">直接人工</span><span class="val">6.24</span></div>
            <div class="calc-row"><span class="lbl">期间费用</span><span class="val">13.00</span></div>
            <div class="calc-row"><span class="lbl">NRE 摊薄</span><span class="val">2.60</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row calc-total" style="font-size:18px;"><span class="lbl">完全成本合计</span><span class="val">232.94 元/台</span></div>
            <div class="calc-row" style="font-size:12px;color:var(--muted)"><span class="lbl">不含 NRE</span><span class="val">230.34 元/台</span></div>
          </div>
        </div>
      </details>

      <!-- 产物 3: 产能与交期 -->
      <details class="deliverable-card">
        <summary>
          <div class="card-num">3</div>
          <div class="card-info">
            <div class="card-title">产能与交期评估（ATP）</div>
            <div class="card-meta">可承诺 30 天分批交付 · 关键路径与物料约束 · 无冗余缓冲风险</div>
          </div>
          <div class="card-status status-done">已完成</div>
        </summary>
        <div class="card-body">
          <p><strong>结论：</strong>合同生效后 <strong>30 天</strong>可全部交付，分两批：<strong>第 20 天 200 台</strong>、<strong>第 30 天 300 台</strong>。当前产线可满足，无需加急费。</p>

          <h4>关键路径</h4>
          <table>
            <thead><tr><th>排程环节</th><th class="td-num">周期</th><th>说明</th></tr></thead>
            <tbody>
              <tr><td>PCB 制板</td><td class="td-num">7 天</td><td>4 层 FR-4 沉金 + 阻抗控制，1 拼 4</td></tr>
              <tr><td>物料采购</td><td class="td-num">10 天</td><td>72 项协议价物料 + 15 项现货，长交期料单列</td></tr>
              <tr><td>贴片与测试</td><td class="td-num">10 天</td><td>双面 SMT + DIP + FCT/AOI + 48h 老化</td></tr>
              <tr><td>组装与包装</td><td class="td-num">3 天</td><td>三防涂覆 + 组装 + 防静电包装</td></tr>
              <tr style="background:var(--surface-soft);font-weight:700;"><td>合计（关键路径）</td><td class="td-num">30 天</td><td>无冗余缓冲</td></tr>
            </tbody>
          </table>

          <h4>交付约束与风险</h4>
          <table>
            <thead><tr><th>约束项</th><th>影响</th><th>应对</th></tr></thead>
            <tbody>
              <tr><td>WiFi 模组（ESP32-WROOM-32）标准交期 45 天</td><td>超出 30 天排产窗口，可能压垮首批</td><td>提前备货，或启用替代料</td></tr>
              <tr><td>30 天等于极限工期</td><td>任一环节延误即超期</td><td>首批 200 台提前至第 18 天，留 2 天缓冲</td></tr>
              <tr><td>客户封样 / 客供料清单未确认</td><td>确认延迟会整体顺延</td><td>合同生效前完成封样与客供清单确认</td></tr>
            </tbody>
          </table>

          <p><strong>承诺边界：</strong>可承诺交期以「合同生效 + 客户封样确认」为起点；数量、客供料范围或设计变更需重新核算交期。</p>
        </div>
      </details>

      <!-- 产物 4: 批量阶梯 -->
      <details class="deliverable-card">
        <summary>
          <div class="card-num">4</div>
          <div class="card-info">
            <div class="card-title">批量阶梯定价对比</div>
            <div class="card-meta">5/50/500/5,000 台四档 · 目标净利率 17.6%</div>
          </div>
          <div class="card-status status-done">已完成</div>
        </summary>
        <div class="card-body">
          <table>
            <thead>
              <tr><th>批量</th><th>类型</th><th>BOM折扣</th><th class="td-num">NRE摊薄</th><th>制造费率</th><th class="td-num">完全成本</th><th class="td-num">出厂价</th><th class="td-num">含税价</th><th>净利率</th></tr>
            </thead>
            <tbody>
              <tr><td>5 台</td><td>打样</td><td>0%</td><td class="td-num">260.00</td><td>100%</td><td class="td-num">970.00</td><td class="td-num">1,281.58</td><td class="td-num">1,448.18</td><td>17.6%</td></tr>
              <tr><td>50 台</td><td>小批</td><td>5%</td><td class="td-num">26.00</td><td>95%</td><td class="td-num">312.00</td><td class="td-num">410.53</td><td class="td-num">463.90</td><td>17.6%</td></tr>
              <tr style="background:var(--primary-soft);font-weight:700;"><td>500 台</td><td>首批★</td><td>10%</td><td class="td-num">2.60</td><td>90%</td><td class="td-num">232.94</td><td class="td-num td-highlight">318.89</td><td class="td-num td-highlight">360.35</td><td>17.6%</td></tr>
              <tr><td>5,000 台</td><td>年框</td><td>15%</td><td class="td-num">0.26</td><td>85%</td><td class="td-num">199.19</td><td class="td-num td-success">276.65</td><td class="td-num td-success">312.61</td><td>17.6%</td></tr>
            </tbody>
          </table>
          <p><strong>💡 建议：</strong>以"年框 5,000 台 276.65 元/台（含税 312.61 元）"作为洽谈筹码，远低于客户目标价 350 元。</p>
        </div>
      </details>

      <!-- 产物 5: 客户分层 -->
      <details class="deliverable-card">
        <summary>
          <div class="card-num">5</div>
          <div class="card-info">
            <div class="card-title">客户分层报价矩阵</div>
            <div class="card-meta">战略/大客户/一般/新客四档 · 华东智洗适用一般客户档</div>
          </div>
          <div class="card-status status-done">已完成</div>
        </summary>
        <div class="card-body">
          <table>
            <thead>
              <tr><th>客户层级</th><th>年采购额</th><th>折扣率</th><th class="td-num">500台出厂价</th><th class="td-num">含税价</th><th class="td-num">税后净利</th><th>净利率</th><th>适用说明</th></tr>
            </thead>
            <tbody>
              <tr><td>战略客户</td><td>≥500 万</td><td>-10%</td><td class="td-num">287.00</td><td class="td-num">324.31</td><td class="td-num">38.06</td><td>11.7%</td><td>需总经理特批</td></tr>
              <tr><td>大客户</td><td>100-500 万</td><td>-5%</td><td class="td-num">302.95</td><td class="td-num">342.33</td><td class="td-num">50.71</td><td>14.7%</td><td>需年框承诺</td></tr>
              <tr style="background:var(--primary-soft);font-weight:700;"><td>一般客户</td><td>&lt;100 万</td><td>0%</td><td class="td-num td-highlight">318.89</td><td class="td-num td-highlight">360.35</td><td class="td-num">63.36</td><td>17.6%</td><td>华东智洗适用</td></tr>
              <tr><td>新客户（首单）</td><td>无历史</td><td>+6%</td><td class="td-num">338.02</td><td class="td-num">381.96</td><td class="td-num">74.28</td><td>20.6%</td><td>首单溢价</td></tr>
            </tbody>
          </table>
          <p><strong>华东智洗定位：</strong>首次合作但年预估 5,000-8,000 台（约 180-288 万/年），建议按"一般客户"报价，同时展示年框 5,000 台 → 276.65 元升级路径。</p>
        </div>
      </details>

      <!-- 产物 6: 净利验证 -->
      <details class="deliverable-card">
        <summary>
          <div class="card-num">6</div>
          <div class="card-info">
            <div class="card-title">税后净利验证报告</div>
            <div class="card-meta">出厂价 318.89 → 税后净利 57.89 → 净利率 17.6%（达标）</div>
          </div>
          <div class="card-status status-done">已完成</div>
        </summary>
        <div class="card-body">
          <div class="calc-card">
            <div class="calc-title">📈 税后净利验证</div>
            <div class="calc-row"><span class="lbl">出厂价</span><span class="val">318.89</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row"><span class="lbl">增值税（销项税额）</span><span class="val">41.46</span></div>
            <div class="calc-row"><span class="lbl">  └ 计算：318.89 × 13%</span><span class="val">—</span></div>
            <div class="calc-row"><span class="lbl">增值税（进项税额）</span><span class="val">-25.52</span></div>
            <div class="calc-row"><span class="lbl">  └ 物料进项+制造进项（约174.10×14.7%）</span><span class="val">—</span></div>
            <div class="calc-row" style="color:var(--primary);font-weight:600;"><span class="lbl">增值税实际税负</span><span class="val">15.94</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row"><span class="lbl">附加税（城建+教育+地方）</span><span class="val">1.91</span></div>
            <div class="calc-row"><span class="lbl">  └ 计算：15.94 × 12%</span><span class="val">—</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row"><span class="lbl">税前利润</span><span class="val">68.10</span></div>
            <div class="calc-row"><span class="lbl">  └ 计算：318.89 - 232.94 - 15.94 - 1.91</span><span class="val">—</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row"><span class="lbl">所得税（15%，高新企业）</span><span class="val">10.21</span></div>
            <div class="calc-row"><span class="lbl">  └ 计算：68.10 × 15%</span><span class="val">—</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row calc-total" style="font-size:16px;color:var(--success);"><span class="lbl">税后净利润</span><span class="val">57.89</span></div>
            <div class="calc-row calc-total" style="font-size:16px;color:var(--success);"><span class="lbl">税后净利率</span><span class="val">17.6%</span></div>
            <div class="calc-row" style="font-size:11px;color:var(--muted)"><span class="lbl">财务口径达标判定</span><span class="val" style="color:var(--success);font-weight:700;">✅ 净利率 17.6% ≥ 基准 15%，达标</span></div>
          </div>
        </div>
      </details>

      <!-- 产物 7: 压力测试 -->
      <details class="deliverable-card">
        <summary>
          <div class="card-num">7</div>
          <div class="card-info">
            <div class="card-title">压力测试报告</div>
            <div class="card-meta">3 种极端场景 · 含中间计算过程</div>
          </div>
          <div class="card-status status-done">已完成</div>
        </summary>
        <div class="card-body">
          <h4>场景 A · 铜价上涨 10%</h4>
          <div class="calc-card">
            <div class="calc-row"><span class="lbl">PCB 裸板原价</span><span class="val">15.00</span></div>
            <div class="calc-row"><span class="lbl">铜价变动</span><span class="val">+10%</span></div>
            <div class="calc-row"><span class="lbl">  └ 铜箔占 PCB 成本 30%，铜价+10%→PCB+15.3%</span><span class="val">—</span></div>
            <div class="calc-row" style="color:var(--warning);font-weight:600;"><span class="lbl">PCB 新价</span><span class="val">17.30（+2.30）</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row"><span class="lbl">完全成本</span><span class="val">235.24（+2.30）</span></div>
            <div class="calc-row"><span class="lbl">出厂价</span><span class="val">318.89（不变）</span></div>
            <div class="calc-row"><span class="lbl">  └ 铜价波动 ≤3% 时不调价（公司政策）</span><span class="val">—</span></div>
            <div class="calc-row calc-total"><span class="lbl">净利率</span><span class="val">16.8%（-0.8%）</span></div>
            <div class="calc-row" style="font-size:11px;color:var(--success)"><span class="lbl">结论</span><span class="val">✅ 不调价，仍在容忍区间（≥15%）</span></div>
          </div>

          <h4>场景 B · 美元汇率升至 7.5（进口芯片 +5%）</h4>
          <div class="calc-card">
            <div class="calc-row"><span class="lbl">STM32F407（进口芯片）</span><span class="val">28.50 → 29.93（+1.43）</span></div>
            <div class="calc-row"><span class="lbl">  └ 汇率 7.0→7.5，进口芯片+5%</span><span class="val">—</span></div>
            <div class="calc-row"><span class="lbl">其他进口器件</span><span class="val">+3.77</span></div>
            <div class="calc-row"><span class="lbl">  └ 进口器件占比约35%</span><span class="val">—</span></div>
            <div class="calc-row" style="color:var(--warning);font-weight:600;"><span class="lbl">BOM 物料新价</span><span class="val">179.30（+5.20）</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row"><span class="lbl">完全成本</span><span class="val">238.14（+5.20）</span></div>
            <div class="calc-row"><span class="lbl">出厂价建议</span><span class="val">324.09（微调+1.6%）</span></div>
            <div class="calc-row calc-total"><span class="lbl">净利率</span><span class="val">15.9%（-1.7%）</span></div>
            <div class="calc-row" style="font-size:11px;color:var(--warning)"><span class="lbl">结论</span><span class="val">⚠️ 建议微调至 324.09 元，或签汇率波动>5%调价条款</span></div>
          </div>

          <h4>场景 C · 主要物料普涨 8%</h4>
          <div class="calc-card">
            <div class="calc-row"><span class="lbl">BOM 物料普涨</span><span class="val">174.10 → 188.03（+13.93）</span></div>
            <div class="calc-row"><span class="lbl">  └ 全品类普涨 8%</span><span class="val">—</span></div>
            <div class="calc-divider"></div>
            <div class="calc-row"><span class="lbl">完全成本</span><span class="val">246.87（+13.93）</span></div>
            <div class="calc-row" style="color:var(--danger);font-weight:600;"><span class="lbl">出厂价必须调整</span><span class="val">332.92（标准调价+4.4%）</span></div>
            <div class="calc-row calc-total" style="color:var(--danger);"><span class="lbl">净利率</span><span class="val">13.2%（-4.4%）</span></div>
            <div class="calc-row" style="font-size:11px;color:var(--danger)"><span class="lbl">结论</span><span class="val">❌ 低于警戒线，必须调价并在报价单增加"物料普涨超5%双方协商调整"条款</span></div>
          </div>

          <h4>压力测试总览</h4>
          <table>
            <thead><tr><th>场景</th><th>完全成本变动</th><th>出厂价调整</th><th>净利率</th><th>处置策略</th></tr></thead>
            <tbody>
              <tr><td>铜价 +10%</td><td class="td-num">+2.30</td><td>不调价</td><td>16.8%</td><td><span class="tag tag-green">维持</span></td></tr>
              <tr><td>汇率 7.5</td><td class="td-num">+5.20</td><td>微调 +1.6%</td><td>15.9%</td><td><span class="tag tag-orange">建议调价或签汇率条款</span></td></tr>
              <tr><td>物料普涨 +8%</td><td class="td-num">+13.93</td><td>标准调价 +4.4%</td><td style="color:var(--danger);font-weight:700;">13.2%</td><td><span class="tag tag-red">必须调价</span></td></tr>
            </tbody>
          </table>
        </div>
      </details>

      <!-- 产物 8: 竞品分析 -->
      <details class="deliverable-card">
        <summary>
          <div class="card-num">8</div>
          <div class="card-info">
            <div class="card-title">竞品参考分析</div>
            <div class="card-meta">我方 360.35 vs 竞品A 429 元 · 市场区间 320-450 元</div>
          </div>
          <div class="card-status status-done">已完成</div>
        </summary>
        <div class="card-body">
          <table>
            <thead>
              <tr><th>对比维度</th><th>我方报价</th><th>竞品A（客户提及）</th><th>市场区间（1688）</th></tr>
            </thead>
            <tbody>
              <tr><td>单价（未税）</td><td class="td-num td-highlight">318.89 元</td><td class="td-num">~380 元</td><td class="td-num">280-400 元</td></tr>
              <tr><td>单价（含税 13%）</td><td class="td-num td-success">360.35 元</td><td class="td-num">~429.40 元</td><td class="td-num">316-452 元</td></tr>
              <tr><td>价格定位</td><td><span class="tag tag-green">市场中低位</span></td><td>市场中高位</td><td>—</td></tr>
              <tr><td>BOM 代购</td><td><span class="tag tag-green">包工包料</span></td><td>未知</td><td>多数包工包料</td></tr>
              <tr><td>测试等级</td><td><span class="tag tag-green">FCT+AOI+48h老化</span></td><td>未知</td><td>多数仅 FCT</td></tr>
              <tr><td>老化测试</td><td><span class="tag tag-green">48h（增值项）</span></td><td>❓ 未知</td><td><span class="tag tag-red">多数不做</span></td></tr>
              <tr><td>PCB 工艺</td><td><span class="tag tag-green">4层沉金+阻抗控制</span></td><td>❓ 未知</td><td>多数 2层喷锡</td></tr>
              <tr><td>NRE（首单）</td><td class="td-num">1,300 元</td><td>未知</td><td class="td-num">500-2,000 元</td></tr>
              <tr><td>交付周期</td><td><span class="tag tag-green">30 天（确定性承诺）</span></td><td>未知</td><td>20-45 天</td></tr>
              <tr><td>质保</td><td>12 个月</td><td>未知</td><td>6-12 个月</td></tr>
            </tbody>
          </table>

          <h4>差异化卖点（销售话术）</h4>
          <p>1. <strong>测试等级差异</strong>：我方 48h 老化 + AOI 全检，同行多数不做老化，这是品质溢价的基础</p>
          <p>2. <strong>PCB 工艺差异</strong>：4 层沉金 + 阻抗控制，同行常用 2 层喷锡，信号完整性更好</p>
          <p>3. <strong>交付确定性</strong>：30 天分批交付写入合同，排程已确认，无加急费</p>
          <p>4. <strong>年框升级路径</strong>：5,000 台触发 276.65 元档，长期合作更有竞争力</p>

          <div class="calc-card" style="background:var(--success-soft);border-color:var(--success);">
            <div class="calc-title" style="color:var(--success);">✅ 价格底线建议</div>
            <p>不建议主动降价。若客户坚持 350 元含税：</p>
            <p>• 推荐"年框 5,000 台"方案（含税 312.61 元）</p>
            <p>• 或"客供阻容感"方案（含税约 345 元）</p>
          </div>
        </div>
      </details>

      <!-- 产物 9: 正式报价单 -->
      <details class="deliverable-card">
        <summary>
          <div class="card-num">9</div>
          <div class="card-info">
            <div class="card-title">正式报价单（PDF 预览）</div>
            <div class="card-meta">标准格式 · 可直接发客户 · 含完整商务条款</div>
          </div>
          <div class="card-status status-info">待发送</div>
        </summary>
        <div class="card-body">
          <div class="quote-preview">
      ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
               青岛创智物联电子有限公司
                    报 价 单
      ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

      报价单号：QT-20260910-EW-001
      报价日期：2026年09月10日
      有效期至：2026年10月10日（30天）

      ─────────────────────────────
      【客户信息】
      客户名称：华东智洗科技有限公司
      联 系 人：张经理
      联系电话：138-8888-6666

      ─────────────────────────────
      【产品信息】
      产品名称：AIoT 变频洗衣机智能控制器
      型    号：RFQ-EW-WM-AI15
      规格描述：4层FR-4沉金PCB，双面SMT+DIP插件，
                87项BOM，三防涂覆，组装包装
      首批数量：500台
      分批交付：200台（第20天）+ 300台（第30天）

      ─────────────────────────────
      【报价明细】
      序号  项目                    单价(元)   数量   金额(元)
      ─────────────────────────────────────────────────
      1    BOM物料（包工包料）      174.10    500    87,050.00
      2    SMT贴片加工              18.50     500     9,250.00
      3    DIP插件加工               6.50     500     3,250.00
      4    测试（FCT+AOI+老化）     12.00     500     6,000.00
      5    直接人工分摊              6.24     500     3,120.00
      6    期间费用分摊             13.00     500     6,500.00
      7    NRE（首单一次性）         2.60     500     1,300.00
           ─────────────────────────────────────────────
           出厂价合计（未税）                 500   160,175.00
           增值税（13%）                      —     20,822.75
           ─────────────────────────────────────────────
           报价合计（含税）                   500   180,175.00

      单价（未税）：318.89 元/台
      单价（含税）：360.35 元/台

      ─────────────────────────────
      【商务条款】
      付款方式：预付30%，到货验收后70%
      交付周期：30天（200台第20天 / 300台第30天）
      测试标准：FCT功能测试 + AOI外观检测 + 48h老化测试
      质量标准：IPC-A-610 Class 2，RoHS 2.0
      认    证：CCC + CQC（客户要求）
      包    装：防静电袋+吸塑托盘，20片/外箱
      质    保：12个月，不良品返修或更换
      NRE费用：1,300元（钢网+程序烧录+首件确认，一次性）

      ─────────────────────────────
      【批量优惠】
      年采购量达到5,000台，单价可降至 276.65 元/台（未税）
      含税单价：312.61 元/台

      ─────────────────────────────
      【备注】
      1. 报价基于客户提供的完整Gerber文件和BOM清单
      2. 元器件价格波动超过±10%时，双方协商调整
      3. 设计变更需提前2周通知，双方确认后执行
      4. 客供物料需提前确认清单并签署质量保证协议

      ─────────────────────────────
      青岛创智物联电子有限公司（盖章）
      授权代表：________________
      日    期：2026年09月10日

      ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
          </div>
        </div>
      </details>

      <!-- 产物 10: 议价策略 -->
      <details class="deliverable-card">
        <summary>
          <div class="card-num">10</div>
          <div class="card-info">
            <div class="card-title">议价策略与达标路径</div>
            <div class="card-meta">3 条 350 元含税达标路径 · 含销售话术建议</div>
          </div>
          <div class="card-status status-done">已完成</div>
        </summary>
        <div class="card-body">
          <div class="path-card recommended">
            <div class="path-tag">推荐</div>
            <div class="path-title">路径 A：签年框 5,000 台承诺</div>
            <div class="path-price">含税 312.61 元/台</div>
            <div class="path-desc">
              出厂价 276.65 元（年框折扣 15%）→ 含税 312.61 元<br>
              净利率维持 17.6%｜利润影响：无<br>
              优势：满足客户 350 目标、守住利润率、锁定长期订单
            </div>
          </div>

          <div class="path-card">
            <div class="path-title">路径 B-1：客供全部阻容感 + 主控 STM32F407</div>
            <div class="path-price">含税 ~335 元/台</div>
            <div class="path-desc">
              客供阻容感（~42元）+ 客供 STM32F407（28.50元）→ 成本下降约 70.5 元/台<br>
              净利率 ~15%｜利润影响：-15%<br>
              <span style="color:var(--danger)">⚠️ 风险：来料质量风险、齐套管理复杂</span>
            </div>
          </div>

          <div class="path-card">
            <div class="path-title">路径 B-2：仅客供阻容感（主控仍代购）</div>
            <div class="path-price">含税 ~345 元/台</div>
            <div class="path-desc">
              仅客供阻容感 → 成本下降约 42 元/台<br>
              净利率 ~16%｜利润影响：-10%<br>
              <span style="color:var(--warning)">⚠️ 注意：来料管理成本增加</span>
            </div>
          </div>

          <div class="path-card">
            <div class="path-title">路径 C：取消 48h 老化（降为 24h）</div>
            <div class="path-price">含税 ~346.8 元/台</div>
            <div class="path-desc">
              取消老化测试 → 成本 -12 元/台<br>
              净利率 ~16.5%｜利润影响：-6%<br>
              <span style="color:var(--danger)">❌ 不建议：牺牲品质卖点，失去差异化优势</span>
            </div>
          </div>

          <div class="path-card">
            <div class="path-title">路径 D：延长付款至 60 天 + 年框</div>
            <div class="path-price">含税 ~330 元/台</div>
            <div class="path-desc">
              付款延长 + 年框承诺组合方案<br>
              净利率 ~15%｜利润影响：-15%<br>
              <span style="color:var(--warning)">⚠️ 资金占用成本增加</span>
            </div>
          </div>

          <h4>销售话术建议</h4>
          <div class="calc-card" style="background:#fff;border:2px solid var(--primary);font-style:italic;">
            <p>"张经理，我们的报价 360.35 元含税已经比对方低 16%。而且我们的测试标准包含 48 小时老化测试和 AOI 全检，同行多数不做老化。如果贵司年采购能达到 5,000 台，我们可以直接给到 312.61 元含税，远低于 350 的目标。这是基于长期合作的诚意价。"</p>
          </div>
        </div>
      </details>

      <!-- 产物 11: 风险与跟踪 -->
      <details class="deliverable-card">
        <summary>
          <div class="card-num">11</div>
          <div class="card-info">
            <div class="card-title">风险预警与后续跟踪</div>
            <div class="card-meta">5 项风险清单 · T+3/T+7/T+14 跟踪计划</div>
          </div>
          <div class="card-status status-warn">需关注</div>
        </summary>
        <div class="card-body">
          <h4>当前风险清单</h4>
          <table>
            <thead><tr><th>#</th><th>风险项</th><th>等级</th><th>影响</th><th>应对策略</th><th>责任人</th></tr></thead>
            <tbody>
              <tr><td>1</td><td>目标价 350 vs 我方 360.35，超 2.9%</td><td><span class="tag tag-red">高</span></td><td>客户可能议价或流失</td><td>出示年框方案（312.61元）或客供方案</td><td>销售</td></tr>
              <tr><td>2</td><td>STM32F407 协议价过期 3 天，现货价+8%</td><td><span class="tag tag-orange">中</span></td><td>成本增加 2.28 元/台</td><td>已同步采购核实，48h内更新协议价</td><td>采购</td></tr>
              <tr><td>3</td><td>WiFi 模组交期 45 天 > 排产窗口 30 天</td><td><span class="tag tag-orange">中</span></td><td>可能导致延期交付</td><td>建议提前备货或换替代料 ESP32-WROOM-32E</td><td>采购</td></tr>
              <tr><td>4</td><td>交付排程无冗余缓冲（30天=极限）</td><td><span class="tag tag-orange">中</span></td><td>任何环节延误即超期</td><td>建议第一批 200 台提前至第 18 天</td><td>生产计划</td></tr>
              <tr><td>5</td><td>客户首次合作，信用等级未知</td><td><span class="tag tag-green">低</span></td><td>付款风险</td><td>预付 30% 降低风险</td><td>财务</td></tr>
            </tbody>
          </table>

          <h4>后续跟踪计划</h4>
          <table>
            <thead><tr><th>时间</th><th>动作</th><th>触发条件</th><th>产出</th></tr></thead>
            <tbody>
              <tr><td>T+1 天</td><td>发送正式报价单 PDF</td><td>销售确认后自动触发</td><td>报价单已发送，进入跟踪期</td></tr>
              <tr><td>T+3 天</td><td>首次跟进提醒</td><td>客户未回复</td><td>"建议电话跟进，发送压力测试报告"</td></tr>
              <tr><td>T+7 天</td><td>二次跟进 + 降价建议</td><td>客户 7 天未决策</td><td>"发送年框优惠方案 + 邀请参观产线"</td></tr>
              <tr><td>T+14 天</td><td>风险预警</td><td>报价有效期过半</td><td>"建议客户确认是否锁定当前价格"</td></tr>
              <tr><td>客户回复后</td><td>反馈分析</td><td>收到客户反馈</td><td>自动生成降价方案组合 / 赢单分析</td></tr>
              <tr><td>客户接受后</td><td>转化归档</td><td>确认下单</td><td>标记"已中标"，推送合同智控 + 履约交付</td></tr>
              <tr><td>客户拒绝后</td><td>流失分析</td><td>确认丢单</td><td>原因分析 + 下次报价建议</td></tr>
            </tbody>
          </table>
        </div>
      </details>

      <!-- 底部信息 -->
      <!-- <div style="text-align:center;margin-top:40px;padding-top:20px;border-top:1px solid var(--line);color:var(--muted);font-size:12px;">
        <p>卡奥斯 COSMOPlat · 销供协同数字人 · 商机报价</p>
        <p>项目编号：RFQ-EW-WM-AI15 ｜ 报价单号：QT-20260910-EW-001</p>
        <p>版本 V2.0</p>
      </div> -->

      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'QuotePreviewDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '报价方案预览 · RFQ-EW-WM-AI15'
    }
  },
  data() {
    return {
      drawerSize: 'min(1180px, 96vw)'
    }
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
        if (!val) {
          this.$emit('close')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.quote-preview-document {
    --ink: #172033;
    --muted: #64748b;
    --sub: #8593a3;
    --line: #dfe6f1;
    --bg: #f3f6fb;
    --surface: #fff;
    --surface-soft: #f1f5f9;
    --primary: #0052d9;
    --primary-deep: #003a9b;
    --primary-soft: #eaf1ff;
    --accent: #2d7ff9;
    --accent-soft: #e5f0ff;
    --success: #16a34a;
    --success-soft: #e6f4ea;
    --warning: #d97706;
    --warning-soft: #fff3e3;
    --danger: #dc2626;
    --danger-soft: #fdeaea;
    --cosmos-blue: #0052d9;
    --cosmos-dark: #0a1a3a;
  }
  .quote-preview-document,
  .quote-preview-document * { box-sizing: border-box; }
  .quote-preview-document {
    background: var(--bg);
    color: var(--ink);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    line-height: 1.7;
  }
  .container { max-width: 1100px; margin: 0 auto; padding: 32px 32px 60px; }

  /* 品牌头部 */
  .brand-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 18px 28px;
    background: linear-gradient(135deg, var(--cosmos-dark) 0%, var(--cosmos-blue) 100%);
    border-radius: 10px 10px 0 0;
    margin: 0 -32px 0 -32px; width: calc(100% + 64px);
  }
  .brand-logo { display: flex; align-items: center; gap: 14px; }
  .brand-logo .logo-box {
    width: 44px; height: 44px; background: #fff; border-radius: 8px;
    display: flex; align-items: center; justify-content: center;
    font-size: 11px; font-weight: 800; color: var(--cosmos-blue); letter-spacing: -0.5px;
  }
  .brand-logo .brand-text { color: #fff; }
  .brand-logo .brand-text .main { font-size: 18px; font-weight: 800; letter-spacing: 1px; }
  .brand-logo .brand-text .sub { font-size: 11px; opacity: 0.75; margin-top: 1px; }
  .brand-doc-type { color: #a8c6ff; font-size: 13px; font-weight: 600; text-transform: uppercase; letter-spacing: 2px; }

  /* 核心结论卡 */
  .hero-card {
    background: linear-gradient(135deg, var(--cosmos-dark) 0%, #0d2b5e 60%, var(--cosmos-blue) 100%);
    color: #fff; padding: 32px 36px; border-radius: 14px;
    margin: 28px 0 24px; position: relative; overflow: hidden;
  }
  .hero-card::before {
    content: ''; position: absolute; top: -50%; right: -10%; width: 300px; height: 300px;
    background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);
  }
  .hero-title { font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 2px; color: #a8c6ff; margin-bottom: 12px; }
  .hero-main { font-size: 24px; font-weight: 800; line-height: 1.4; margin-bottom: 16px; }
  .hero-stats { display: flex; gap: 32px; flex-wrap: wrap; }
  .hero-stat { display: flex; flex-direction: column; }
  .hero-stat .val { font-size: 22px; font-weight: 800; }
  .hero-stat .lbl { font-size: 12px; opacity: 0.7; margin-top: 2px; }
  .hero-badge {
    display: inline-flex; align-items: center; gap: 6px;
    background: rgba(255,255,255,0.15); padding: 6px 14px; border-radius: 20px;
    font-size: 12px; font-weight: 600; margin-top: 16px;
  }

  /* 风险条 */
  .risk-bar {
    background: var(--danger-soft); border-left: 4px solid var(--danger);
    padding: 14px 18px; border-radius: 8px; margin: 16px 0;
    display: flex; align-items: flex-start; gap: 10px;
  }
  .risk-bar .icon { color: var(--danger); font-size: 18px; flex-shrink: 0; }
  .risk-bar .content { flex: 1; }
  .risk-bar .title { font-weight: 700; color: var(--danger); font-size: 14px; }
  .risk-bar .desc { color: var(--ink); font-size: 13px; margin-top: 4px; }

  /* 折叠卡片 */
  .deliverable-card {
    background: var(--surface); border: 1px solid var(--line);
    border-radius: 12px; margin-bottom: 14px; overflow: hidden;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  }
  .deliverable-card summary {
    display: flex; align-items: center; gap: 12px;
    padding: 16px 20px; cursor: pointer; list-style: none;
    background: var(--surface-soft);
    border-bottom: 1px solid var(--line);
    transition: background 0.2s;
  }
  .deliverable-card summary:hover { background: #e8eef5; }
  .deliverable-card summary::-webkit-details-marker { display: none; }
  .card-num {
    width: 28px; height: 28px; border-radius: 50%;
    background: var(--primary); color: #fff;
    display: flex; align-items: center; justify-content: center;
    font-size: 12px; font-weight: 700; flex-shrink: 0;
  }
  .card-info { flex: 1; }
  .card-title { display: flex; justify-content: flex-start; font-size: 15px; font-weight: 700; color: var(--ink); }
  .card-meta { font-size: 12px; color: var(--muted); margin-top: 2px; }
  .card-status {
    padding: 4px 10px; border-radius: 12px; font-size: 11px; font-weight: 600;
    flex-shrink: 0;
  }
  .status-done { background: var(--success-soft); color: var(--success); }
  .status-warn { background: var(--warning-soft); color: var(--warning); }
  .status-info { background: var(--primary-soft); color: var(--primary); }
  .card-body { padding: 20px; }

  /* 表格 */
  table {
    width: 100%; border-collapse: separate; border-spacing: 0;
    font-size: 12px; margin: 14px 0 18px; background: #fff;
    border: 1px solid var(--line); border-radius: 8px;
    overflow: hidden;
  }
  thead th {
    background: var(--surface-soft); font-weight: 600;
    padding: 14px 14px; text-align: left;
    border-bottom: 1px solid var(--line);
    color: #475569; font-size: 12px; letter-spacing: 0.3px;
    white-space: nowrap;
  }
  tbody tr { background: #fff; }
  tbody tr:nth-child(even) { background: #fbfcfe; }
  tbody tr:hover { background: var(--accent-soft); }
  tbody td {
    padding: 14px 14px; border-bottom: 1px solid #f1f5f9;
    vertical-align: middle; line-height: 1.75;
  }
  tbody tr:last-child td { border-bottom: none; }
  .td-num { font-variant-numeric: tabular-nums; text-align: right; }
  .td-center { text-align: center; }
  .td-highlight { font-weight: 700; color: var(--primary); }
  .td-danger { color: var(--danger); font-weight: 600; }
  .td-success { color: var(--success); font-weight: 600; }

  /* 子折叠 */
  .sub-group {
    background: var(--surface-soft); border-radius: 8px;
    margin: 10px 0; overflow: hidden;
  }
  .sub-group summary {
    padding: 10px 14px; font-size: 13px; font-weight: 600;
    background: #e8eef5; cursor: pointer; list-style: none;
    display: flex; align-items: center; gap: 8px;
  }
  .sub-group summary::-webkit-details-marker { display: none; }
  .sub-group .sub-body { padding: 12px; overflow-x: auto; }
  .sub-group .sub-body table { min-width: 820px; }
  .sub-count {
    background: var(--primary); color: #fff; font-size: 10px;
    padding: 2px 8px; border-radius: 10px; margin-left: auto;
  }

  /* 计算卡片 */
  .calc-card {
    background: var(--surface-soft); border-radius: 8px;
    padding: 14px 16px; margin: 10px 0;
  }
  .calc-title { font-weight: 700; font-size: 13px; margin-bottom: 8px; color: var(--primary-deep); }
  .calc-row { display: flex; justify-content: space-between; padding: 4px 0; font-size: 12px; }
  .calc-row .lbl { color: var(--muted); }
  .calc-row .val { font-variant-numeric: tabular-nums; font-weight: 600; }
  .calc-divider { border-top: 1px dashed var(--line); margin: 6px 0; }
  .calc-total { font-weight: 800; color: var(--primary); font-size: 14px; }

  /* 报价单样式 */
  .quote-preview {
    background: #fff; border: 2px solid var(--line); border-radius: 8px;
    padding: 24px; font-family: "Courier New", monospace; font-size: 12px; line-height: 1.8;
    white-space: pre-wrap;
  }

  /* 路径卡片 */
  .path-card {
    border: 2px solid var(--line); border-radius: 10px;
    padding: 14px 16px; margin: 10px 0;
    position: relative;
  }
  .path-card.recommended { border-color: var(--success); background: var(--success-soft); }
  .path-tag {
    position: absolute; top: -10px; right: 12px;
    background: var(--success); color: #fff;
    padding: 2px 10px; border-radius: 10px;
    font-size: 11px; font-weight: 700;
  }
  .path-title { font-weight: 700; font-size: 14px; margin-bottom: 6px; }
  .path-desc { font-size: 12px; color: var(--muted); }
  .path-price { font-size: 18px; font-weight: 800; color: var(--primary); margin: 8px 0; }

  /* 小标签 */
  .tag {
    display: inline-flex; align-items: center;
    padding: 2px 8px; border-radius: 4px; font-size: 11px; font-weight: 600;
    margin-right: 4px;
  }
  .tag-green { background: var(--success-soft); color: var(--success); }
  .tag-red { background: var(--danger-soft); color: var(--danger); }
  .tag-orange { background: var(--warning-soft); color: var(--warning); }
  .tag-blue { background: var(--primary-soft); color: var(--primary); }

  h3 { font-size: 17px; font-weight: 700; color: var(--primary-deep); margin: 24px 0 12px; }
  h4 { font-size: 14px; font-weight: 700; color: var(--ink); margin: 16px 0 8px; }
  p { margin: 8px 0; font-size: 13px; color: var(--ink); }

  .section-title {
    font-size: 18px; font-weight: 700; color: var(--primary-deep);
    margin: 32px 0 16px; padding-bottom: 10px;
    border-bottom: 2px solid var(--primary);
  }

.quote-preview-document {
  min-height: 100%;
}
</style>
